import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { StyledListViewContainer, StyledBlockTitle } from './index.style';
import Ancestors from './components/ancestors';
import ShowMoreToggle from './components/show-more-toggle';
import Descendents from './components/descendents';
import { FilterProcessor } from '../../filters/util';
import type { SrpState } from '../../../reducers';

const maxLengthOfAbbreviatedDescendentList = 5;

const Categories = () => {
    const {
        resultsPage: { categoriesFilter },
    } = useSelector((data: SrpState): SrpState => data);

    const { ancestorCategories, descendentCategories, selectedCategorySeoDisplayName } =
        categoriesFilter;

    const [isShowFullSubCategories, setIsShowFullSubCategories] = useState(false);

    const ancestorCategoriesProcessed = new FilterProcessor(ancestorCategories)
        .markAsChecked(selectedCategorySeoDisplayName)
        .getItems();

    const descendentCategoriesProcessed = new FilterProcessor(descendentCategories)
        .markAsChecked(selectedCategorySeoDisplayName)
        .hideOverflow(maxLengthOfAbbreviatedDescendentList, isShowFullSubCategories)
        .getItems();

    const maxLengthOfDescendentCategories = descendentCategoriesProcessed.length;

    return (
        <StyledListViewContainer>
            <StyledBlockTitle>Category</StyledBlockTitle>
            <Ancestors ancestorCategoriesProcessed={ancestorCategoriesProcessed} />
            <Descendents descendentCategoriesProcessed={descendentCategoriesProcessed} />
            <ShowMoreToggle
                maxLengthOfAbbreviatedDescendentList={maxLengthOfAbbreviatedDescendentList}
                maxLengthOfDescendentCategories={maxLengthOfDescendentCategories}
                isShowFullSubCategories={isShowFullSubCategories}
                setIsShowFullSubCategories={setIsShowFullSubCategories}
            />
        </StyledListViewContainer>
    );
};

export default Categories;
